import Main from "~/layout/App/Index.vue";

export default {
    path: "/support",
    component: Main,
    meta: {
        breadcrumb: [{ name: "breadcrumb.support.main", route: "support.index" }],
    },
    children: [
        {
            path: "",
            name: "support.index",
            component: () => import("~/views/Support/Index.vue"),
            meta: {
                breadcrumb: [{ name: "breadcrumb.overview" }],
            }
        }
    ]
};


